import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Button from '../../components/Button';
import Header from '../../components/Header';

import './styles.css';

const Success = ({ onSignIn }) => (
  <div styleName="center">
    <Header as="h2"><FormattedMessage id="forgot-password.success" defaultMessage="Success!" /></Header>
    <Button onClick={onSignIn}><FormattedMessage id="forgot-password.login" defaultMessage="Login" /></Button>
  </div>
);
Success.propTypes = {
  onSignIn: PropTypes.func.isRequired,
};

export default Success;
